import React from 'react';
import { Item } from '../../types';
import styles from './Experience.module.css';
import ExperienceCard from '../ExperienceCard/ExperienceCard';

type Props = { experience: Item[] };

const Experience = ({ experience }: Props) => {
  return (
    <div className={styles.mainContainer}>
      <h2 className={styles.heading}>Experience</h2>

      <div className={styles.expContainer}>
        {experience.map(({ fields }) => {
          return <ExperienceCard key={fields.companyLink} fields={fields} />;
        })}
      </div>
    </div>
  );
};

export default Experience;
